import ChromeClient from './src/ChromeClient';
/* Needed for webpack to be sane */
module.exports = ChromeClient;



// WEBPACK FOOTER //
// ./index.js